export function initAnimations() {
    // Animate elements on scroll
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-slide-up')
            }
        })
    }, observerOptions)

    // Observe service cards
    const serviceCards = document.querySelectorAll('.service-card')
    serviceCards.forEach((card, index) => {
        card.style.opacity = '0'
        card.style.transform = 'translateY(20px)'
        card.style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`
        observer.observe(card)
    })

    // Animate chart bars
    const chartBars = document.querySelectorAll('.chart-bar')
    const chartObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                chartBars.forEach((bar, index) => {
                    setTimeout(() => {
                        bar.style.animation = 'growUp 1.5s ease-out forwards'
                    }, index * 200)
                })
            }
        })
    }, { threshold: 0.5 })

    if (chartBars.length > 0) {
        chartObserver.observe(chartBars[0].parentElement)
    }

    // Add intersection observer callback for animations
    const animateOnScroll = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1'
                entry.target.style.transform = 'translateY(0)'
            }
        })
    }

    // Create new observer for the animation callback
    const animationObserver = new IntersectionObserver(animateOnScroll, observerOptions)
    
    // Observe all animated elements
    serviceCards.forEach(element => {
        animationObserver.observe(element)
    })
}